// extracted by mini-css-extract-plugin
export default {"finePrintContainer":"auth-flow-promo-offer-fine-print-module__finePrintContainer___fwN8F","finePrint":"auth-flow-promo-offer-fine-print-module__finePrint___Ctl3X"};